import { merge } from "lodash/fp";

import baseConfig from "@readai/common/config";

import type { Config as DevelopmentConfig } from "./config.development";
import type { Config as ProductionConfig } from "./config.production";
import type { Config as StagingConfig } from "./config.staging";
import type { Config as TestConfig } from "./config.test-env";

type AppConfig =
  | TestConfig
  | DevelopmentConfig
  | StagingConfig
  | ProductionConfig;

// The pattern is to put configuration that is applicable to all environments here
// and then override it in the environment-specific config files.
// DO NOT PUT SECRETS IN HERE!!!
const createCommonAppConfig = (_config: AppConfig) => ({
  sentry: {
    DSN: "https://6df7af02dacf407aba6f9c7a3353e8f9@o992397.ingest.sentry.io/5997695",
  },
});

const createCommonConfig = (config: AppConfig) =>
  merge({ ...baseConfig }, createCommonAppConfig(config));

export default createCommonConfig;
